import API from "../../helpers/API";
import {
  SET_USER_SESSION,
  SET_DEPARTMENTS,
  SET_USER_NAME_FOR_LOGIN,
  SET_VERIFY_OTP_FLAG_EMAIL,
  SET_VERIFY_OTP_FLAG_MOBILE,
  SET_GET_OTP_RESPONSE,
  SET_VERIFY_USER,
  SET_VERIFY_SHOW,
  SET_EMAIL_OTP_FLAG_VERIFY,
  SET_MOBILE_OTP_FLAG_VERIFY,
  SET_BOTH_OTP_VERIFICATION,
  SET_OTP_VERIFICATION_EMAIL_STATUS,
  SET_OTP_VERIFICATION_MOBILE_STATUS,
  SET_API_REPO_VERSION,
  GET_OTP_TIMER,
} from "../../common/constants/ActionTypes";
import { toastr } from "react-redux-toastr";
import {
  API_REPO_VERSION,
  LOGIN,
  DEPARTMENTS,
  VERIFYOTP,
  ADMINOTPS,
  VERIFY_USER,
  VERIFICATIONOTP_FOR_USERVERIFY,
  RESET_PASSWORD,
  CHECK_USER,
  UPDATE_VERIFY_USER,
} from "../../common/constants/endpoints";
import label from "../labels/login_en.json";
import { handleError, handleResponseMessage } from "../../common/actions/commonActions";
export const loginAction = (captchaId, loginDetails, props) => {
  return async (dispatch) => {
    try {
      let userName;
      if (loginDetails.usertype === "mobile") {
        userName = loginDetails.mobileNo;
      } else {
        userName = loginDetails.emailId.trim();
      }
      let request = {
        username: userName,
        password: loginDetails.password,
        captchaId: captchaId,
        departmentName: loginDetails.department,
        enteredCaptcha: loginDetails.enteredCaptcha,
        roleName: "admin",
      };
      // if (loginDetails.otpVerificationStatusFlag) {
      let response = await API.post(LOGIN, request);

      if (response && response.data) {
        sessionStorage.setItem("session", JSON.stringify(response.data));
        if (
          response.data.roleName === "Coordinator" ||
          response.data.roleName === "Principal"
        ) {
          props.history.push("/admin/dashboard");
        } else {
          props.history.push("/admin/dashboard");
        }

        dispatch({
          payload: response.data.jwtResponse.token,
          authData: response.data,
          type: SET_USER_SESSION,
        });
        // }
      } else {
        toastr.error(label.OTP_verification_required);
      }
    } catch (error) {
      let errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;

      if (
        errorMessage &&
        errorMessage.includes(label.You_are_already_loggedin)
      ) {
        toastr.confirm(errorMessage);
      } else {
        toastr.error(label.Login_failed, errorMessage);
      }
    }
  };
};
export const getDepartment = () => {
  return async (dispatch) => {
    let response = await API.get(DEPARTMENTS);
    dispatch({
      payload: response.data,
      type: SET_DEPARTMENTS,
    });
  };
};

export const generateOTP = (reqBody, props) => {
  return async (dispatch) => {
    try {
      const userName = reqBody.email !== "" ? reqBody.email : reqBody.mobile;
      const departmentName = reqBody.departmentName;
      const departmentId = reqBody.depatmentId;

      let checkuser = await API.get(
        `${CHECK_USER}/${userName}/${departmentId}/${departmentName}`
      );
      if (checkuser.data === true) {
        let verifyUserResponse = await API.get(`${VERIFY_USER}/${userName}`);

        if (
          verifyUserResponse.data &&
          verifyUserResponse.data.isMobileVerified === true &&
          verifyUserResponse.data.isEmailVerified === true
        ) {
          let response = await API.post(ADMINOTPS, reqBody);
          dispatch({
            payload: response.data,
            type: SET_GET_OTP_RESPONSE,
          });
          dispatch({
            payload: response.data,
            type: GET_OTP_TIMER,
          });
          if (
            response.data &&
            response.data[0].type === "email" &&
            response.data.length === 1
          ) {
            dispatch({
              payload: false,
              type: SET_VERIFY_OTP_FLAG_EMAIL,
            });
            dispatch({
              payload: true,
              type: SET_VERIFY_OTP_FLAG_MOBILE,
            });
            dispatch({
              payload: false,
              type: SET_OTP_VERIFICATION_EMAIL_STATUS,
            });
          } else if (
            response.data &&
            response.data[0].type === "mobile" &&
            response.data.length === 1
          ) {
            dispatch({
              payload: false,
              type: SET_VERIFY_OTP_FLAG_MOBILE,
            });
            dispatch({
              payload: true,
              type: SET_VERIFY_OTP_FLAG_EMAIL,
            });
            dispatch({
              payload: false,
              type: SET_OTP_VERIFICATION_MOBILE_STATUS,
            });
          } else if (response.data.length === 2) {
            dispatch({
              payload: false,
              type: SET_VERIFY_OTP_FLAG_MOBILE,
            });
            dispatch({
              payload: false,
              type: SET_VERIFY_OTP_FLAG_EMAIL,
            });
            dispatch({
              payload: true,
              type: SET_BOTH_OTP_VERIFICATION,
            });
            dispatch({
              payload: false,
              type: SET_OTP_VERIFICATION_EMAIL_STATUS,
            });
            dispatch({
              payload: false,
              type: SET_OTP_VERIFICATION_MOBILE_STATUS,
            });
          } else {
            dispatch({
              payload: true,
              type: SET_VERIFY_OTP_FLAG_MOBILE,
            });
            dispatch({
              payload: true,
              type: SET_VERIFY_OTP_FLAG_EMAIL,
            });
          }

          if (reqBody.sendOtpTo === "email") {
            toastr.success(label.OTP_sent_registered_email);
          } else if (reqBody.sendOtpTo === "mobile") {
            toastr.success(label.OTP_sent_registered_mobile);
          } else {
            toastr.success(label.OTP_sent_registered_email_mobile);
          }

          dispatch({
            type: SET_VERIFY_SHOW,
            payload: false,
          });
        } else {
          dispatch({
            type: SET_VERIFY_SHOW,
            payload: true,
          });

          let verifyUserObject = verifyUserResponse.data;
          verifyUserObject.type = reqBody.type;
          verifyUserObject.username = userName;

          dispatch({
            type: SET_VERIFY_USER,
            payload: verifyUserObject,
          });

          dispatch({
            payload: false,
            type: SET_EMAIL_OTP_FLAG_VERIFY,
          });

          dispatch({
            payload: false,
            type: SET_MOBILE_OTP_FLAG_VERIFY,
          });

          props.history.push("/verifyuser");
        }
      }
    } catch (error) {
      handleError(error);
    }
  };
};

export const verificationOTP = (reqBody) => {
  return async (dispatch) => {
    try {
      let response = await API.post(VERIFYOTP, reqBody);
      if (response.data) {
        dispatch({
          payload: reqBody.username,
          type: SET_USER_NAME_FOR_LOGIN,
        });
        if (reqBody.otpType === "email") {
          dispatch({
            payload: true,
            type: SET_VERIFY_OTP_FLAG_EMAIL,
          });
          dispatch({
            payload: true,
            type: SET_OTP_VERIFICATION_EMAIL_STATUS,
          });
        } else {
          dispatch({
            payload: true,
            type: SET_VERIFY_OTP_FLAG_MOBILE,
          });
          dispatch({
            payload: true,
            type: SET_OTP_VERIFICATION_MOBILE_STATUS,
          });
        }
        toastr.success(label.OTP_verification_successful);
      } else {
        toastr.error(label.OTP_verification_unsuccessful);
      }
    } catch (error) {
      handleError(error);
    }
  };
};

export const updateVerifyUser = (requestBody) => {
  return async function (dispatch) {
    try {
      await API.patch(UPDATE_VERIFY_USER, requestBody, {});
    } catch (error) {
      handleError(error);
    }
  };
};

export const verificationOTPForUserVerify = (reqBody) => {
  return async (dispatch) => {
    try {
      let response = await API.post(VERIFICATIONOTP_FOR_USERVERIFY, reqBody);
      if (response.data) {
        if (reqBody.otpType === "email" || reqBody.otpType === "mobile") {
          let params = {
            username: reqBody.username,
            type: reqBody.otpType,
            value: true,
          };
          dispatch(updateVerifyUser(params));
        }
        if (reqBody.otpType === "email") {
          dispatch({
            payload: true,
            type: SET_EMAIL_OTP_FLAG_VERIFY,
          });
        } else {
          dispatch({
            payload: true,
            type: SET_MOBILE_OTP_FLAG_VERIFY,
          });
        }
        toastr.success(label.OTP_verification_successful);
      } else {
        toastr.error(label.OTP_verification_unsuccessful);
      }
    } catch (error) {
      handleError(error);
    }
  };
};

export const resetPassword = (reqBody, props) => {
  return async (dispatch) => {
    try {
      const response = await API.post(RESET_PASSWORD, reqBody);
      if (response.status === 200) {
        toastr.success(label.Kindly_relogin_using_password);
      }
      if (response.status === 200) {
        toastr.success(label.Password_updated_successfully);
        props.history.push("/admin/login");
      }
    } catch (error) {
      handleError(error);
    }
  };
};
export const getAPIRepoVersion = () => {
  return async (dispatch) => {
    let response = await API.get(API_REPO_VERSION);
    dispatch({
      type: SET_API_REPO_VERSION,
      payload: response ? response.data : "",
    });
  };
};
